import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { NavigationBarService } from '@app/shared/navigation-bar/navigation-bar.service';
import { of } from 'rxjs/internal/observable/of';
import { delay } from 'rxjs/internal/operators/delay';
import { tap } from 'rxjs/internal/operators/tap';

interface iDropdown { id: any; title: string }
@Component({
  selector: 'navaar-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  @Input() public items: Array<iDropdown> = [];
  @Input() public selected: iDropdown | null = null;
  @Output() public selectedChange: EventEmitter<iDropdown> = new EventEmitter<iDropdown>();
  @Input() placeholder: string = "---";
  @Input() public isShowFullScreen: boolean = true;
  @Input() public showIcon: boolean = false;
  public isOpen: boolean = false;
  public selectId: string = '';
  constructor(@Inject(DOCUMENT) private readonly document: Document,
            public readonly navigationBarService: NavigationBarService,) {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 5; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    this.selectId = result;
  }
  public open(): void {
    this.isOpen = true
    of(true).pipe(
      delay(100),
      tap(() => {
        if (this.selectId)
          this.document?.querySelector('#' + this.selectId)?.scrollIntoView({ block: 'center' });
      })
    ).subscribe()
  }
}
